import { apiClient as api } from "./httpClient";

export interface OptionItem {
  id: string;
  name: string;
}

// Opções para o modal "Mudar Perfil": entidades do usuário e perfis do usuário naquela entidade.
export const sessionOptionsService = {
  getEntitiesByUser: async (userId: string): Promise<OptionItem[]> => {
    const response = await api.get(`/CurrentSessionUsers/entities/by-user/${userId}`);
    return Array.isArray(response.data) ? response.data : [];
  },
  getProfilesByUserEntity: async (userId: string, entityId: string): Promise<OptionItem[]> => {
    const response = await api.get(`/CurrentSessionUsers/profiles/by-user-entity/${userId}/${entityId}`);
    return Array.isArray(response.data) ? response.data : [];
  },
};
